module.exports = __webpack_public_path__ + "img/shield-halved-solid 1.28071628.svg";